import styled, { css } from "styled-components";

import { fadeUpAnimation } from "@sellernote/shipda-kr/src/components/landing/index.styles";
import { COLOR, TEXT_COLOR } from "@sellernote/ui/src/sds-v2/styles/colors";
import { setFontStyle } from "@sellernote/ui/src/sds-v2/styles/typography";
import { mobile } from "@sellernote/ui/src/styles/functions";

const containerWrapper = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${COLOR.primary_50};
`;

const container = styled.div`
  width: 1128px;
  padding: 80px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;

  ${mobile(css`
    width: 100%;
    padding: 48px 16px;
    height: auto;
  `)};

  ${fadeUpAnimation}

  > .update-at {
    ${setFontStyle("Body3")};
    color: ${TEXT_COLOR.black_3};
    margin-top: 16px;
    animation-delay: 0.5s;

    ${mobile(css`
      ${setFontStyle("Body4")};
      margin-top: 12px;
    `)};
  }
`;

const numbersList = styled.ul`
  display: flex;
  gap: 16px;

  ${mobile(css`
    flex-direction: column;
    width: 100%;
    gap: 32px;
  `)};
`;

const numbersItem = styled.li<{ delay: string }>`
  width: 365px;
  animation-delay: ${({ delay }) => delay};

  ${mobile(css`
    width: 100%;
  `)};

  > span,
  p {
    display: block;
  }

  > .title {
    display: flex;
    align-items: center;
    ${setFontStyle("Body2")};
    color: ${TEXT_COLOR.black_2};

    > em {
      margin-left: 2px;
      ${setFontStyle("Body4")};
    }
  }

  > .numbers {
    margin-top: 4px;
    ${setFontStyle("Head1")};
    color: ${COLOR.primary_600};

    ${mobile(css`
      margin-top: 0;
    `)};
  }

  > .desc {
    margin-top: 12px;
    ${setFontStyle("Body3")};
    color: ${TEXT_COLOR.black_3};

    ${mobile(css`
      margin-top: 8px;
      ${setFontStyle("Body4")};
    `)};
  }
`;

export default {
  containerWrapper,
  container,
  numbersList,
  numbersItem,
};
